<template>
  <div class = "Note">
    <div class = "Title">
      <input v-if = "control.titleState" id = "NoteTitle" ref = "NoteTitle" v-model = "title" placeholder = "无标题笔记" @input = "SaveNote" @blur = "RenameNode">
    </div>
    <div id = "NoteEditor" ref = "NoteEditor"></div>

    <!-- 文本纠错结果对话框 -->
    <Dialog v-if = "showCorrectionDialog" title = "文本纠错建议"
      acceptName = "" cancelName = "关闭"
      icon = "/icon/纠错.svg"
      width = "600px"
      maxWidth = "100%"
      @dialogCancel = "showCorrectionDialog = false">
      <div style="max-height: 400px; overflow-y: auto; padding-top: 10px;">
        <div v-if="correctionList.length === 0" style="text-align: center; color: #4caf50; padding: 20px;">
          <i class="iconfont icon-success" style="font-size: 24px; margin-bottom: 10px; display: block;"></i>
          没有发现明显的拼写或语法错误
        </div>
        <div v-else>
          <div style="color: #666; font-size: 12px; margin-bottom: 10px; padding: 0 5px;">
            共发现 {{ correctionList.length }} 处建议修改：
          </div>
          <div v-for="(item, index) in correctionList" :key="index" 
            style="background: #fff; border: 1px solid #eee; border-radius: 4px; margin-bottom: 10px; padding: 12px; transition: all 0.2s;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <div style="display: flex; align-items: center; gap: 10px; cursor: pointer;" @click="LocateCorrection(item)" title="点击定位（仅提示）">
                <span style="color: #e2696c; text-decoration: underline wavy #e2696c; background: #fff1f0; padding: 2px 6px; border-radius: 4px;">{{ item.sourceWord }}</span>
                <i class="iconfont icon-arrow-right" style="color: #999; font-size: 12px;"></i>
                <span style="color: #4caf50; font-weight: bold; background: #f6ffed; padding: 2px 6px; border-radius: 4px;">{{ item.targetWord }}</span>
              </div>
              <div style="font-size: 12px; color: #999;">
                {{ item.type || '拼写/语法错误' }}
              </div>
            </div>
            
            <!-- 上下文预览 (如果有) -->
            <div v-if="item.contextHtml" v-html="'...' + item.contextHtml + '...'" 
                 style="font-size: 12px; color: #666; background: #f9f9f9; padding: 6px; border-radius: 4px; margin-top: 6px; line-height: 1.6;">
            </div>
            <div v-else-if="item.context" style="font-size: 12px; color: #666; background: #f9f9f9; padding: 6px; border-radius: 4px; margin-top: 6px;">
              ...{{ item.context }}...
            </div>
            
            <!-- 操作按钮 -->
            <div style="display: flex; justify-content: flex-end; margin-top: 8px; gap: 8px;">
              <button @click="LocateCorrection(item)" 
                style="background: #2196f3; color: white; border: none; padding: 4px 12px; border-radius: 4px; cursor: pointer; font-size: 12px;">
                定位原文
              </button>
              <button @click="ApplyCorrection(item)" 
                style="background: #4caf50; color: white; border: none; padding: 4px 12px; border-radius: 4px; cursor: pointer; font-size: 12px;">
                应用修改
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <!-- 保存版本对话框 -->
    <Dialog v-if = "showSaveVersionDialog" title = "保存新版本"
      acceptName = "保存" cancelName = "取消"
      icon = "/icon/save.svg"
      :accept = "SaveVersion"
      @dialogCancel = "showSaveVersionDialog = false">
      <div style="padding-top: 10px;">
        <input v-model="versionName" placeholder="请输入版本名称" style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #eee; background: #fff; color: #333;">
      </div>
    </Dialog>

    <!-- 历史版本对话框 -->
    <Dialog v-if = "showHistoryDialog" title = "历史版本"
      acceptName = "" cancelName = "关闭"
      icon = "/icon/refresh.svg"
      width = "600px"
      maxWidth = "100%"
      @dialogCancel = "showHistoryDialog = false">
      <div style="max-height: 300px; overflow-y: auto; padding-top: 10px;">
        <div v-if="versionList.length === 0" style="text-align: center; color: #999;">暂无历史版本</div>
        <div v-for="v in versionList" :key="v.id" style="display: flex; justify-content: space-between; align-items: center; padding: 8px; border-bottom: 1px solid #eee;">
          <div>
            <div style="font-weight: bold; color: #333;">{{ v.versionName }}</div>
            <div style="font-size: 12px; color: #666;">{{ v.createTime }}</div>
          </div>
          <div>
            <button @click="ViewVersion(v)" style="background: #4caf50; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 12px; margin-right: 5px;">查看</button>
            <button @click="RestoreVersion(v)" style="background: #e2696c; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 12px;">回溯</button>
          </div>
        </div>
      </div>
    </Dialog>

    <!-- 通用提示/确认对话框 (放在最后以确保显示在最上层) -->
    <Dialog v-if = "control.dialog.state" :title = "control.dialog.title"
      :acceptName = "control.dialog.buttonName.accept"
      :cancelName = "control.dialog.buttonName.cancel"
      :content = "control.dialog.content"
      :icon = "control.dialog.icon"
      :accept = "control.dialog.accept"
      @dialogCancel = "control.dialog.state = false">
    </Dialog>

    <!-- 查看版本内容对话框 -->
    <Dialog v-if = "showViewVersionDialog" title = "版本内容预览"
      acceptName = "" cancelName = "关闭"
      icon = "/icon/open.svg"
      width = "800px"
      maxWidth = "100%"
      @dialogCancel = "showViewVersionDialog = false">
      <div style="max-height: 400px; overflow-y: auto; padding-top: 10px;">
        <pre style="white-space: pre-wrap; color: #333; font-family: monospace;">{{ viewVersionContent }}</pre>
      </div>
    </Dialog>

    <!-- AI 辅助对话框 -->
    <Dialog v-if = "showAIDialog" title = "AI 辅助写作"
      :acceptName = "aiResult ? '采纳' : '生成'"
      cancelName = "取消"
      icon = "/icon/logo.svg"
      width = "600px"
      maxWidth = "100%"
      :accept = "aiResult ? AcceptAIResult : GenerateAIResult"
      @dialogCancel = "showAIDialog = false">
      <div style="padding-top: 10px;">
        <div style="margin-bottom: 10px;">
          <div style="color: #666; font-size: 12px; margin-bottom: 5px;">选中的文本:</div>
          <div style="background: #f4f4f4; padding: 8px; border-radius: 4px; color: #333; max-height: 100px; overflow-y: auto; font-size: 12px; width: 100%; box-sizing: border-box;">
            {{ aiSelectedText }}
          </div>
        </div>
        
        <div style="margin-bottom: 10px;">
          <div style="color: #666; font-size: 12px; margin-bottom: 5px;">修改要求:</div>
          <textarea v-model="aiPrompt" placeholder="请输入您的修改要求（例如：让这段话更通顺、翻译成英文...）" 
            style="width: 100%; height: 80px; padding: 8px; border-radius: 4px; border: 1px solid #eee; background: #fff; color: #333; resize: none; box-sizing: border-box;"></textarea>
        </div>

        <div v-if="aiLoading" style="text-align: center; color: #4caf50; padding: 10px;">
          正在生成中...
        </div>

        <div v-if="aiResult" style="margin-top: 10px;">
          <div style="color: #666; font-size: 12px; margin-bottom: 5px;">AI 生成结果:</div>
          <div style="background: #f9f9f9; padding: 8px; border-radius: 4px; color: #333; border: 1px solid #4caf50; max-height: 150px; overflow-y: auto;">
            {{ aiResult }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 分享对话框 -->
    <Dialog v-if="showShareDialog" title="文档分享"
      acceptName="" cancelName="关闭"
      icon="/icon/share.svg"
      width="500px"
      maxWidth="100%"
      @dialogCancel="showShareDialog = false">
      <div style="padding: 10px;">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
          <span style="color: #333;">开启分享</span>
          <div 
            @click="ToggleShare"
            :style="{ background: isShared ? '#4caf50' : '#e0e0e0' }"
            style="width: 40px; height: 20px; border-radius: 10px; position: relative; cursor: pointer; transition: all 0.3s;">
            <div 
              :style="{ left: isShared ? '22px' : '2px' }"
              style="width: 16px; height: 16px; background: #fff; border-radius: 50%; position: absolute; top: 2px; transition: all 0.3s;">
            </div>
          </div>
        </div>
        
        <div v-if="isShared">
          <div style="color: #666; font-size: 12px; margin-bottom: 5px;">分享链接 (只读)</div>
          <div style="display: flex; gap: 10px;">
            <input type="text" readonly :value="shareUrl" 
              style="flex: 1; background: #f4f4f4; border: 1px solid #eee; color: #333; padding: 6px; border-radius: 4px; font-size: 13px;" />
            <button @click="CopyShareUrl" 
              style="background: #007acc; color: #fff; border: none; padding: 0 12px; border-radius: 4px; cursor: pointer; font-size: 13px;">
              复制
            </button>
          </div>
          <div style="color: #999; font-size: 12px; margin-top: 8px;">
            任何人通过此链接均可查看文档内容
          </div>
        </div>
      </div>
    </Dialog>

    <!-- 主题管理对话框 -->
    <Dialog v-if="showThemeDialog" title="主题管理"
      acceptName="" cancelName="关闭"
      icon="/icon/theme.svg"
      @dialogCancel="showThemeDialog = false">
      <div style="padding: 10px;">
        <!-- 上传区域 -->
        <div style="margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #eee;">
          <div style="color: #333; margin-bottom: 10px; font-weight: bold;">上传新主题</div>
          <div style="display: flex; gap: 10px;">
            <input type="text" v-model="newThemeName" placeholder="主题名称" 
              style="flex: 1; background: #fff; border: 1px solid #eee; color: #333; padding: 6px; border-radius: 4px;" />
            <input type="file" ref="themeFile" accept=".css" style="display: none" @change="HandleThemeFileSelect" />
            <button @click="$refs.themeFile.click()" 
              style="background: #f4f4f4; color: #333; border: 1px solid #eee; padding: 0 12px; border-radius: 4px; cursor: pointer;">
              选择CSS
            </button>
            <button @click="UploadTheme" 
              style="background: #007acc; color: #fff; border: none; padding: 0 12px; border-radius: 4px; cursor: pointer;">
              上传
            </button>
          </div>
          <div v-if="selectedFileName" style="color: #666; font-size: 12px; margin-top: 5px;">
            已选文件: {{ selectedFileName }}
          </div>
        </div>

        <!-- 主题列表 -->
        <div style="max-height: 300px; overflow-y: auto;">
          <div style="color: #333; margin-bottom: 10px; font-weight: bold;">我的主题</div>
          <div v-if="themeList.length === 0" style="text-align: center; color: #999; padding: 20px;">暂无自定义主题</div>
          
          <div v-for="theme in themeList" :key="theme.id" 
            :style="{ background: activeThemeId === theme.id ? '#f0f9eb' : 'transparent' }"
            style="display: flex; justify-content: space-between; align-items: center; padding: 10px; border-bottom: 1px solid #eee; cursor: pointer; transition: all 0.2s;"
            @click="EnableTheme(theme)">
            <div style="flex: 1;">
              <div style="color: #333; font-weight: bold;">
                {{ theme.themeName }}
                <span v-if="activeThemeId === theme.id" style="color: #4caf50; font-size: 12px; margin-left: 5px;">(当前使用)</span>
              </div>
              <!-- <div style="color: #666; font-size: 12px;">{{ theme.createTime }}</div> -->
            </div>
            <button @click.stop="DeleteTheme(theme)" 
              style="background: #e2696c; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 12px;">
              删除
            </button>
          </div>
        </div>
      </div>
    </Dialog>

    <!-- AI 悬浮按钮 -->
    <div v-if="aiButtonVisible" 
      :style="{ top: aiButtonPosition.top + 'px', left: aiButtonPosition.left + 'px' }"
      style="position: fixed; z-index: 10000; cursor: pointer; background: #fff; color: #4caf50; padding: 6px 12px; border-radius: 4px; font-size: 13px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); display: flex; align-items: center; gap: 6px; border: 1px solid #eee; transition: all 0.2s ease;"
      @mousedown.prevent
      @click="OpenAIDialog(true)">
      <div style="width: 14px; height: 14px; display: flex;">
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M512 0c282.7776 0 512 229.2224 512 512s-229.2224 512-512 512S0 794.7776 0 512 229.2224 0 512 0z m0 76.8c-240.3328 0-435.2 194.8672-435.2 435.2s194.8672 435.2 435.2 435.2 435.2-194.8672 435.2-435.2-194.8672-435.2-435.2-435.2z m0 153.6a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m-153.6 230.4a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m307.2 0a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m-153.6 153.6a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z" fill="#4caf50"/></svg>
      </div>
      AI 对话
    </div>
  </div>
</template>

<script>
import Vditor from 'vditor'
import Dialog from '../components/Dialog.vue'

export default {
  components: { Dialog },
  data () {
    return {
      id: 0,
      title: '',
      content: '',
      renameTimer: null,
      saveTimer: null,
      showSaveVersionDialog: false,
      showHistoryDialog: false,
      showViewVersionDialog: false,
      showAIDialog: false,
      aiPrompt: '',
      aiResult: '',
      aiSelectedText: '',
      aiLoading: false,
      aiButtonVisible: false,
      aiButtonPosition: { top: 0, left: 0 },
      versionName: '',
      versionList: [],
      viewVersionContent: '',
      showShareDialog: false,
      shareUrl: '',
      isShared: false,
      // Theme data
      showThemeDialog: false,
      themeList: [],
      activeThemeId: null,
      newThemeName: '',
      selectedFileName: '',
      themeFile: null,
      // Doc correction
      showCorrectionDialog: false,
      correctionList: [],
      // Optimistic lock
      versionLock: null,
      control: {
        titleState: true,
        dialog: {
          // state: false,
          // title: '提示',
          // content: '',
          // name: '',
          // icon: '/icon/warning.svg',
          // buttonName: { accept: '继续', cancel: '再想想' }
        }
      }
    }
  },
  methods: {
    // 初始化编辑器
    InitEditor: function () {
      // 如果是分享页面的路由，坚决不初始化编辑器
      if (this.$route.path && this.$route.path.startsWith('/share/')) {
        return Promise.resolve()
      }
      return new Promise ((resolve) => {
        const _this = this
        // 强力清理 Vditor 可能的缓存垃圾，防止干扰渲染
        localStorage.removeItem('vditorNoteEditor')
        // this.control.titleState = false
        this.$Common.ApiList(this, 'UploadImage').then(url => {
          // Double check: 如果当前路由是分享页，说明用户已跳转，终止操作
          if (this.$route.path && this.$route.path.startsWith('/share/')) return

          this.$Common.SetLoading('正在载入 Markdown 组件包, 请稍候...')
          this.$refs.NoteEditor.value = new Vditor('NoteEditor', {
            cdn: '/vditor',
            width: '100%',
            height: '100%',
            theme: 'classic',
            placeholder: '快些记录下你的灵感吧',
            cache: { enable: false },
            fullscreen: { index: 9999 }, // 防止全屏层级过高，但这里其实我们不希望它全屏
            outline: { position: 'left' },
            resize: { enable: false },
            toolbar: [
              'emoji', 'headings', 'bold', 'italic', 'strike', 'link',
              '|',
              'list', 'ordered-list', 'check', 'outdent', 'indent',
              '|',
              'quote', 'line', 'code', 'inline-code', 'insert-before', 'insert-after',
              '|',
              'upload', 'table',
              '|',
              'undo', 'redo',
              '|',
              // 'fullscreen',
              'edit-mode',
              {
                name: 'more',
                  toolbar: [
                    'both',
                      'export',          // 导出
                      'outline',         // 大纲
                      'preview',         // 预览
                  ],
              },
              {
                name: 'theme',
                tipPosition: 's',
                tip: '主题管理',
                className: 'right',
                icon: '<img src="/icon/theme.svg" style="width: 18px; height: 18px; vertical-align: middle; position: relative; top: -2px;">',
                click () { _this.OpenThemeDialog() }
              },
              '|',
              {
                name: 'aiAssist',
                tipPosition: 's',
                tip: 'AI 辅助',
                className: 'right',
                icon: '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M512 0c282.7776 0 512 229.2224 512 512s-229.2224 512-512 512S0 794.7776 0 512 229.2224 0 512 0z m0 76.8c-240.3328 0-435.2 194.8672-435.2 435.2s194.8672 435.2 435.2 435.2 435.2-194.8672 435.2-435.2-194.8672-435.2-435.2-435.2z m0 153.6a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m-153.6 230.4a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m307.2 0a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m-153.6 153.6a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z" fill="#4caf50"/></svg>',
                click () { _this.OpenAIDialog() }
              },
              {
                name: 'correction',
                tipPosition: 's',
                tip: '文本纠错',
                className: 'right',
                icon: '<img src="/icon/纠错.svg" style="width: 14px; height: 14px;">',
                click: () => {
                  _this.CheckDocCorrection()
                }
              },
              '|',
              {
                name: 'saveVersion',
                tipPosition: 's',
                tip: '保存版本',
                className: 'right',
                icon: '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M893.3 293.3L730.7 130.7c-7.5-7.5-17.6-11.7-28.3-11.7H176c-22.1 0-40 17.9-40 40v704c0 22.1 17.9 40 40 40h672c22.1 0 40-17.9 40-40V321.6c0-10.7-4.2-20.8-11.7-28.3zM360 176h264v144H360V176zm304 672H360V568h304v280z" fill="#b9b9b9"/></svg>',
                click () { _this.showSaveVersionDialog = true }
              },
              {
                name: 'share',
                tipPosition: 's',
                tip: '分享文档',
                className: 'right',
                icon: '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M759.466667 699.733333c-38.4 0-72.533333 17.066667-96 42.666667l-264.533334-153.6c4.266667-17.066667 8.533333-34.133333 8.533334-55.466667 0-17.066667-4.266667-34.133333-8.533334-51.2L659.2 332.8c25.6 29.866667 64 46.933333 100.266667 46.933333 76.8 0 138.666667-61.866667 138.666666-138.666666s-61.866667-138.666667-138.666666-138.666667-138.666667 61.866667-138.666667 138.666667c0 17.066667 4.266667 34.133333 8.533333 51.2l-260.266666 149.333333c-25.6-29.866667-64-46.933333-100.266667-46.933333-76.8 0-138.666667 61.866667-138.666667 138.666667s61.866667 138.666667 138.666667 138.666666c38.4 0 72.533333-17.066667 96-42.666666l264.533333 153.6c-4.266667 17.066667-8.533333 34.133333-8.533333 55.466667 0 76.8 61.866667 138.666667 138.666667 138.666666s138.666667-61.866667 138.666666-138.666666-61.866667-138.666667-138.666666-138.666667z m0-490.666666c32 0 59.733333 27.733333 59.733333 59.733333s-27.733333 59.733333-59.733333 59.733333-59.733333-27.733333-59.733333-59.733333 27.733333-59.733333 59.733333-59.733333zM268.8 593.066667c-32 0-59.733333-27.733333-59.733333-59.733334s27.733333-59.733333 59.733333-59.733333 59.733333 27.733333 59.733333 59.733333-27.733333 59.733333-59.733333 59.733334z m490.666667 187.733333c-32 0-59.733333-27.733333-59.733334-59.733333s27.733333-59.733333 59.733334-59.733334 59.733333 27.733333 59.733333 59.733334-27.733333 59.733333-59.733333 59.733333z" fill="#007acc"/></svg>',
                click () { _this.OpenShareDialog() }
              },
              {
                name: 'history',
                tipPosition: 's',
                tip: '历史版本',
                className: 'right',
                icon: '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" fill="#b9b9b9"/><path d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.1 0.8 4.2 2.3 5.7l171.3 123.9c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39.6c2.6-3.7 1.8-8.7-1.7-11.3z" fill="#b9b9b9"/></svg>',
                click () { 
                  _this.GetVersionList()
                  _this.showHistoryDialog = true 
                }
              }
              // 'record',               // 录音
              // 'code-theme',           // 代码主题
              // 'content-theme',        // 内容主题
              // 'devtools',             // 开发者工具
              // 'info',                 // 信息
              // 'help',                 // 帮助
            ],
            after: () => {
              this.$refs.NoteEditor.value.setTheme('classic', 'light', 'github', '/vditor/dist/css/content-theme')
              this.$refs.NoteEditor.value.setValue('')
              this.control.titleState = true
              this.InitTheme() // 初始化主题

              resolve()
            },
            upload: {
              accept: 'image/jpg, image/jpeg, image/png, image/gif',
              url: url,
              multiple: false,
              fieldName: 'file',
              headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
              },
              format: (files, responseText) => {
                console.log('Vditor Upload Files:', files)
                console.log('Vditor Upload Response:', responseText)
                const res = JSON.parse(responseText)
                const succMap = {}
                if (res.code === 200) {
                  const rawUrl = res.data || ''
                  const cleanUrl = rawUrl.replace(/[`\s]/g, '')
                  
                  // 强制处理所有可能的文件名映射
                  if (files && files.length > 0) {
                    files.forEach(file => {
                      succMap[file.name] = cleanUrl
                    })
                  } else {
                    // 兜底：如果 files 为空，尝试针对粘贴常用的默认名映射
                    succMap['image.png'] = cleanUrl
                  }

                  const result = JSON.stringify({
                    code: 0,
                    msg: '',
                    data: {
                      errFiles: [],
                      succMap: succMap
                    }
                  })
                  console.log('Vditor Format Result:', result)
                  return result
                } else {
                  return JSON.stringify({
                    code: 1,
                    msg: res.message || '上传失败'
                  })
                }
              }
            },
            input: () => {
              // 自动保存: 防抖 1s
              // 注意：这里我们不再向父组件 emit 'SaveNote'，因为父组件的 SaveNote 逻辑是旧的且缺少 versionLock
              // 我们直接调用本组件内部的 SaveNote 方法
              if (_this.saveTimer) clearTimeout(_this.saveTimer)
              _this.saveTimer = setTimeout(() => {
                _this.SaveNote()
              }, 1000)
            },
            focus: () => {
              _this.$emit('EditorFocus', _this.$route.query.urlSlug)
            },
            select: (value) => {
              // 当选择文本时，显示 AI 悬浮按钮
              if (value && value.trim().length > 0) {
                // 更新选中文本
                _this.aiSelectedText = value
                
                // 计算按钮位置
                const selection = window.getSelection()
                if (selection.rangeCount > 0) {
                  const range = selection.getRangeAt(0)
                  const rect = range.getBoundingClientRect()
                  // 显示在选区上方，居中
                  // 需要考虑边界，暂时简单处理
                  _this.aiButtonPosition = {
                    top: rect.top - 40, 
                    left: rect.left + (rect.width / 2) - 40 // 假设按钮宽度约 80px
                  }
                  _this.aiButtonVisible = true
                }
              } else {
                _this.aiButtonVisible = false
              }
            }
          })
        })
      })
    },
    // 读取笔记
    GetNote: function () {
      const _this = this
      this.$Common.SetLoading('正在读取笔记...')
      this.$Common.ApiList(this, 'GetNote').then(url => {
        this.axios.get(url + '/' + this.$route.query.urlSlug).then(res => {
          const resData = res.data
          if (resData.code === 200) {
              const note = resData.data
              // 这里的 note 是 DocContent 对象，它应该包含关联的树节点 ID
              this.id = note.docId
              // 存储乐观锁版本号 (确保覆盖)
              this.versionLock = (note.versionLock !== undefined && note.versionLock !== null) ? note.versionLock : null
              console.log('Optimistic Lock Version:', this.versionLock, 'Raw:', note.versionLock)
              
              // 更新分享状态 (isShare: 1-禁止, 2-启用)
              this.isShared = (parseInt(note.isShare) === 2)
              // 获取分享链接
              this.shareUrl = note.shareUrl || ''
              console.log('Current Note ID loaded:', this.id, 'Share Status:', this.isShared, 'Share URL:', this.shareUrl)
              
              // 如果有缓存笔记, 则优先加载缓存
            const noteCache = localStorage.getItem('Note_' + this.$route.query.urlSlug)
            var noteTitle = note.nodeName
            var noteContent = note.content || ''
            // 防御性处理：确保内容不为 undefined/null，避免编辑器崩溃
            if (typeof noteContent !== 'string') {
              noteContent = ''
            }
            
            if (noteCache !== undefined && noteCache !== null) {
              try {
                const cacheObj = JSON.parse(noteCache)
                noteTitle = cacheObj.title
                noteContent = cacheObj.content
              } catch (e) {
                console.error('Note cache parse failed:', e)
                localStorage.removeItem('Note_' + this.$route.query.urlSlug)
              }
            }
            this.title = noteTitle
            this.$refs.NoteEditor.value.setValue(noteContent)
          } else {
            this.control.dialog = {
              state: true,
              title: '当前笔记获取失败',
              content: resData.message || '获取笔记内容失败',
              icon: '/icon/new.svg',
              buttonName: { accept: '知道了', cancel: '' },
              accept: () => {
                this.control.dialog.state = false
                this.$router.push('/Index')
              }
            }
          }
          setTimeout(() => { _this.$Common.RemoveLoading() }, 150)
        }).catch(() => { this.$Common.NetworkErrorDialog(this) })
      })
    },
    // 保存笔记
    SaveNote: function () {
      // 获取最新内容
      const content = this.$refs.NoteEditor.value.getValue()
      
      // 调试日志：检查 versionLock 状态
      if (this.versionLock === null || this.versionLock === undefined) {
        console.warn('Warning: versionLock is missing before save!', this.versionLock)
      }

      // 构造保存请求体
      const payload = {
        urlSlug: this.$route.query.urlSlug,
        content: content,
        versionLock: Number(this.versionLock) // 强制转换为数字，防止为 undefined
      }
      
      console.log('Saving Note with Payload:', JSON.parse(JSON.stringify(payload)))

      this.$Common.ApiList(this, 'SaveNote').then(url => {
        this.axios.post(url, payload).then(res => {
          if (res.data.code === 200) {
             // 保存成功，更新乐观锁版本号
             // 假设后端返回的新版本号在 data 中，或者我们直接 +1
             // 严谨的做法是后端返回最新的 DocContent 对象或 versionLock
             if (res.data.data && res.data.data.versionLock) {
               this.versionLock = res.data.data.versionLock
             } else {
               // 如果后端没返回，尝试手动 +1 (需确保后端逻辑一致)
               if (this.versionLock !== null) this.versionLock++
             }
             console.log('Save success, new versionLock:', this.versionLock)
             
             // 清除本地缓存（如果保存成功）
             localStorage.removeItem('Note_' + this.$route.query.urlSlug)
          } else {
             // 保存失败处理
             console.error('Save failed:', res.data.message)
             
             // 检查是否是乐观锁冲突 (假设错误码或消息包含特定标识)
             // 这里假设后端返回非 200 即为失败，如果是并发冲突，提示用户刷新
             if (this.$Toast) {
               this.$Toast('保存失败：' + (res.data.message || '未知错误'), 'error')
             }
             
             // 针对并发冲突的特殊提示
             if (res.data.message && (res.data.message.includes('过期') || res.data.message.includes('冲突') || res.data.message.includes('版本'))) {
               this.control.dialog = {
                  state: true,
                  title: '版本冲突',
                  content: '当前文档已被其他人修改，请刷新页面以获取最新内容。',
                  icon: '/icon/warning.svg',
                  buttonName: { accept: '刷新页面', cancel: '取消' },
                  accept: () => {
                    this.control.dialog.state = false
                    location.reload()
                  }
               }
             }
          }
        }).catch(err => {
          console.error('Save request error:', err)
          // 可以在这里做离线缓存逻辑
        })
      })

      this.$emit('UpdateTitle', {
        urlSlug: this.$route.query.urlSlug,
        title: this.title
      })
      // 防抖保存: 每次输入后延迟 1s 保存，如果期间再次输入则重新计时
      if (this.renameTimer) clearTimeout(this.renameTimer)
      this.renameTimer = setTimeout(() => {
        this.RenameNode()
      }, 1000)
    },
    // 执行重命名（立即）
    RenameNode: function () {
      // 如果是被强制调用（如切换文档），先清除可能存在的定时器
      if (this.renameTimer) {
        clearTimeout(this.renameTimer)
        this.renameTimer = null
      }
      if (this.id === 0) return
      this.$emit('RenameNode', {
        id: this.id,
        nodeName: this.title
      })
    },
    // 保存新版本
    SaveVersion: function () {
      if (!this.versionName) {
        if (this.$Toast) this.$Toast('请输入版本名称', 'warning')
        else alert('请输入版本名称')
        return
      }
      this.$Common.ApiList(this, 'SaveVersion').then(url => {
        const payload = {
          urlSlug: this.$route.query.urlSlug,
          versionName: this.versionName,
          content: this.$refs.NoteEditor.value.getValue()
        }
        this.axios.post(url, payload).then(res => {
          if (res.data.code === 200) {
            this.showSaveVersionDialog = false
            this.versionName = ''
            if (this.$Toast) this.$Toast('版本保存成功', 'success')
            else this.$Common.NetworkErrorDialog({ control: { dialog: {} } }, () => {}, '提示', '版本保存成功')
          } else {
            if (this.$Toast) this.$Toast(res.data.message || '保存失败', 'error')
            else alert(res.data.message || '保存失败')
          }
        })
      })
    },
    // 获取历史版本列表
    GetVersionList: function () {
      this.$Common.ApiList(this, 'GetVersions').then(url => {
        // Construct the full URL: /doc/content/{urlSlug}/versions
        const fullUrl = `${url}/${this.$route.query.urlSlug}/versions`
        this.axios.get(fullUrl).then(res => {
          if (res.data.code === 200) {
            this.versionList = res.data.data
          }
        })
      })
    },
    // 查看版本内容
    ViewVersion: function (version) {
      this.$Common.ApiList(this, 'GetVersionContent').then(url => {
        // Construct URL: /doc/content/{urlSlug}/version/{version}
        // Assuming version object has a 'version' field which is the version number
        const fullUrl = `${url}/${this.$route.query.urlSlug}/version/${version.version}`
        this.axios.get(fullUrl).then(res => {
          if (res.data.code === 200) {
            this.viewVersionContent = res.data.data.content
            this.showViewVersionDialog = true
          } else {
            alert(res.data.message || '获取版本内容失败')
          }
        })
      })
    },
    // 回溯版本
    RestoreVersion: function (version) {
      // Deep clone and log the version object to see its real structure
      const versionData = JSON.parse(JSON.stringify(version))
      console.log('RestoreVersion called with (raw):', versionData)
      
      // Check if version identifier exists (could be 'version' or 'id')
      const versionId = versionData.version !== undefined ? versionData.version : versionData.id
      
      if (versionId === undefined) {
        console.error('Version identifier missing. Available fields:', Object.keys(versionData))
        this.control.dialog = {
          state: true,
          title: '错误',
          content: '版本信息不完整，无法回溯。请查看控制台日志。',
          icon: '/icon/warning.svg',
          buttonName: { accept: '确定', cancel: '' },
          accept: () => {
            this.control.dialog.state = false
          }
        }
        return
      }

      // Use custom dialog for confirmation
      this.control.dialog = {
        state: true,
        title: '确认回溯',
        content: `确定要回溯到版本 "${version.versionName}" 吗？当前未保存的内容将丢失。`,
        icon: '/icon/warning.svg',
        buttonName: { accept: '确定', cancel: '取消' },
        accept: () => {
          this.control.dialog.state = false
          this.ExecuteRestore(versionId)
        }
      }
    },
    // 执行回溯请求
    ExecuteRestore: function (versionId) {
      this.$Common.ApiList(this, 'RestoreVersion').then(url => {
        // Construct URL: /doc/content/{urlSlug}/restore/{version}
        const fullUrl = `${url}/${this.$route.query.urlSlug}/restore/${versionId}`
        console.log('Restore request URL:', fullUrl)
        this.axios.post(fullUrl).then(res => {
          if (res.data.code === 200) {
            this.showHistoryDialog = false
            this.GetNote() // Reload note content
            if (this.$Toast) this.$Toast('版本回溯成功', 'success')
            else this.$Common.NetworkErrorDialog({ control: { dialog: {} } }, () => {}, '提示', '版本回溯成功')
          } else {
            if (this.$Toast) {
              this.$Toast(res.data.message || '回溯失败', 'error')
            } else {
              this.control.dialog = {
                state: true,
                title: '回溯失败',
                content: res.data.message || '未知错误',
                icon: '/icon/warning.svg',
                buttonName: { accept: '确定', cancel: '' },
                accept: () => {
                  this.control.dialog.state = false
                }
              }
            }
          }
        }).catch(err => {
          console.error('Restore request failed:', err)
          if (this.$Toast) {
             this.$Toast(err.message || '网络请求异常', 'error')
          } else {
            this.control.dialog = {
              state: true,
              title: '请求出错',
              content: err.message || '网络请求异常',
              icon: '/icon/warning.svg',
              buttonName: { accept: '确定', cancel: '' },
              accept: () => {
                this.control.dialog.state = false
              }
            }
          }
        })
      })
    },
    // 打开 AI 辅助对话框
    OpenAIDialog: function (fromFloating = false) {
      if (!fromFloating) {
        // 如果不是从悬浮按钮触发（如工具栏），则尝试获取当前选择
        const selection = this.$refs.NoteEditor.value.getSelection()
        if (selection && selection.trim() !== '') {
          this.aiSelectedText = selection
        }
      }
      
      if (!this.aiSelectedText || this.aiSelectedText.trim() === '') {
        alert('请先选择需要处理的文本')
        return
      }
      
      this.aiButtonVisible = false // 隐藏悬浮按钮
      this.aiPrompt = ''
      this.aiResult = ''
      this.aiLoading = false
      this.showAIDialog = true
    },
    // 生成 AI 结果 (流式)
    GenerateAIResult: function () {
      if (!this.aiPrompt) {
        alert('请输入修改要求')
        return
      }
      this.aiLoading = true
      this.aiResult = ''
      
      this.$Common.ApiList(this, 'AiChatStream').then(baseUrl => {
        const url = baseUrl
        console.log('AI Request URL:', url)
        
        const payload = {
          content: this.aiSelectedText,
          requirement: this.aiPrompt
        }

        // 使用 fetch 处理流式响应
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/plain',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          },
          body: JSON.stringify(payload)
        }).then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          
          const reader = response.body.getReader()
          const decoder = new TextDecoder('utf-8')
          const _this = this

          function read() {
            return reader.read().then(({ done, value }) => {
              if (done) {
                _this.aiLoading = false
                console.log('Stream complete')
                return
              }
              
              const chunk = decoder.decode(value, { stream: true })
              // 直接追加内容，无需像 EventSource 那样解析 data: 前缀，因为 fetch stream 返回的是原始 body
              // 但如果是 text/event-stream 格式，数据可能包含 data: 前缀，取决于后端实现
              // 后端代码: return chatClient.prompt()...content(); 通常返回纯文本流或 SSE
              // 如果是标准的 SSE，每一行是 "data: ...\n\n"
              // 但 Spring AI 的 .content() 通常返回 Flux<String>，即纯文本流片段
              // 让我们先假设是纯文本流直接追加。如果发现有 data: 前缀再调整。
              // 根据 Spring AI 文档，.content() 返回的是 content string fragments.
              
              _this.aiResult += chunk
              // 滚动到底部
              // TODO: 这里如果能获取 DOM 元素滚动最好，暂时依靠 Vue 更新
              
              return read()
            })
          }

          return read()
        }).catch(err => {
          console.error('AI generation failed:', err)
          this.aiLoading = false
          alert('AI 生成失败: ' + err.message)
        })
      })
    },
    // 采纳 AI 结果
    AcceptAIResult: function () {
      // 插入/替换选中的文本
      // Vditor 的 insertValue 默认会在光标处插入，如果有选区则替换选区
      this.$refs.NoteEditor.value.insertValue(this.aiResult)
      this.showAIDialog = false
      // 触发自动保存
      this.$emit('SaveNote', this.$route.query.urlSlug)
    },
    // 打开分享对话框
    OpenShareDialog: function () {
      this.showShareDialog = true
      // 如果未启用分享，则清空 URL
      if (!this.isShared) {
        this.shareUrl = ''
      }
      // 如果已启用分享且 URL 为空 (可能是旧数据)，则尝试获取一次
      else if (this.isShared && !this.shareUrl) {
        this.$Common.ApiList(this, 'ShareUrl').then(url => {
          const fullUrl = `${url}/${this.id}`
          this.axios.get(fullUrl).then(res => {
            if (res.data.code === 200) {
              this.shareUrl = res.data.data
            }
          })
        })
      }
    },
    // 切换分享状态
    ToggleShare: function () {
      if (this.isShared) {
        // 关闭分享
        this.$Common.ApiList(this, 'ShareDisable').then(url => {
          this.axios.post(url + '/' + this.id).then(res => {
            if (res.data.code === 200) {
              this.isShared = false
              this.shareUrl = ''
              // 更新文件树状态 (isShare: 1-禁止)
              if (this.$parent && this.$parent.$refs.FileManager) {
                this.$parent.$refs.FileManager.UpdateNodeShareStatusByUrlSlug(this.$route.query.urlSlug, 1)
              }
            } else {
              alert(res.data.message || '关闭分享失败')
            }
          })
        })
      } else {
        // 开启分享
        this.$Common.ApiList(this, 'ShareEnable').then(url => {
          this.axios.post(url + '/' + this.id).then(res => {
            if (res.data.code === 200) {
              this.isShared = true
              this.shareUrl = res.data.data
              // 更新文件树状态 (isShare: 2-启用)
              if (this.$parent && this.$parent.$refs.FileManager) {
                this.$parent.$refs.FileManager.UpdateNodeShareStatusByUrlSlug(this.$route.query.urlSlug, 2)
              }
            } else {
              alert(res.data.message || '开启分享失败')
            }
          })
        })
      }
    },
    // 复制分享链接
    CopyShareUrl: function () {
      if (!this.shareUrl) return
      
      const copyToClipboard = (text) => {
        // 尝试使用 navigator.clipboard (仅在安全上下文 HTTPS 中有效)
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text)
        }
        // 降级方案：使用 document.execCommand
        return new Promise((resolve, reject) => {
          try {
            const textArea = document.createElement('textarea')
            textArea.value = text
            // 将 textarea 移出可视区域
            textArea.style.position = 'fixed'
            textArea.style.left = '-9999px'
            textArea.style.top = '0'
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            const successful = document.execCommand('copy')
            document.body.removeChild(textArea)
            if (successful) {
              resolve()
            } else {
              reject(new Error('execCommand copy failed'))
            }
          } catch (err) {
            reject(err)
          }
        })
      }

      copyToClipboard(this.shareUrl).then(() => {
        if (this.$Toast) this.$Toast('链接已复制到剪贴板', 'success')
        else alert('链接已复制到剪贴板')
      }).catch((err) => {
        console.error('Copy failed:', err)
        if (this.$Toast) this.$Toast('复制失败，请手动复制链接', 'error')
        else alert('复制失败，请手动复制链接')
      })
    },
    // 初始化主题
    InitTheme: function () {
      this.$Common.ApiList(this, 'ThemeEnabled').then(url => {
        this.axios.get(url).then(res => {
          if (res.data.code === 200 && res.data.data) {
            this.activeThemeId = res.data.data.id
            this.ApplyTheme(res.data.data.themeUrl)
          } else {
            // 如果没有启用的主题，确保清除之前的自定义样式
            this.ApplyTheme(null)
          }
        })
      })
    },
    // 打开主题管理对话框
    OpenThemeDialog: function () {
      this.showThemeDialog = true
      this.GetThemeList()
    },
    // 获取主题列表
    GetThemeList: function () {
      this.$Common.ApiList(this, 'ThemeList').then(url => {
        this.axios.get(url).then(res => {
          if (res.data.code === 200) {
            this.themeList = res.data.data
          }
        })
      })
    },
    // 处理文件选择
    HandleThemeFileSelect: function (event) {
      const file = event.target.files[0]
      if (file) {
        this.themeFile = file
        this.selectedFileName = file.name
        // 如果没有输入名称，自动填充文件名（去后缀）
        if (!this.newThemeName) {
          this.newThemeName = file.name.replace(/\.css$/i, '')
        }
      }
    },
    // 上传主题
    UploadTheme: function () {
      if (!this.themeFile) {
        if (this.$Toast) this.$Toast('请选择CSS文件', 'warning')
        else alert('请选择CSS文件')
        return
      }
      if (!this.newThemeName) {
        if (this.$Toast) this.$Toast('请输入主题名称', 'warning')
        else alert('请输入主题名称')
        return
      }

      this.$Common.ApiList(this, 'ThemeUpload').then(url => {
        const formData = new FormData()
        formData.append('file', this.themeFile)
        formData.append('themeName', this.newThemeName)

        this.axios.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
          if (res.data.code === 200) {
            if (this.$Toast) this.$Toast('上传成功', 'success')
            else alert('上传成功')
            // 重置表单
            this.themeFile = null
            this.selectedFileName = ''
            this.newThemeName = ''
            this.$refs.themeFile.value = '' // 清空 input
            // 刷新列表
            this.GetThemeList()
          } else {
            if (this.$Toast) this.$Toast(res.data.message || '上传失败', 'error')
            else alert(res.data.message || '上传失败')
          }
        })
      })
    },
    // 文本纠错
    CheckDocCorrection: function () {
      if (!this.$refs.NoteEditor || !this.$refs.NoteEditor.value) return
      
      const content = this.$refs.NoteEditor.value.getValue()
      if (!content || content.trim() === '') {
        if (this.$Toast) this.$Toast('文档内容为空', 'warning')
        else alert('文档内容为空')
        return
      }
      
      this.$Common.ApiList(this, 'DocCorrection').then(url => {
        // 使用 $Toast 的 loading 模式（如果支持）或者使用 Common.SetLoading
        // 注意：SetLoading 默认是全局遮罩，用户体验可能不好
        // 这里尝试使用 Toast 显示“正在处理中...”
        let loadingToast = null
        if (this.$Toast) {
           loadingToast = this.$Toast('AI 正在检查文本，请稍候...', 'loading', 0) // duration 0 表示不自动关闭
        } else {
           this.$Common.SetLoading('正在检查文本...')
        }
        
        // 去除首尾空白符后再发送
        const trimmedContent = content.trim()
        this.axios.post(url, { content: trimmedContent }).then(res => {
          // 延迟关闭 Loading，直到弹窗逻辑处理完毕
          const closeLoading = () => {
            if (loadingToast) loadingToast.hide() // 关闭 Toast
            this.$Common.RemoveLoading() // 确保遮罩也关闭
          }
          
          // 兼容后端返回数组或对象结构
          // const data = Array.isArray(res.data) ? res.data : res.data.data
          // 如果后端直接返回 List (没有 code 字段)，或者 code 为 200
          if (Array.isArray(res.data) || res.data.code === 200) {
            const rawList = Array.isArray(res.data) ? res.data : (res.data.data || [])
            
            // 过滤掉包含换行符、空白符的“错误”提示
            this.correctionList = rawList.filter(item => {
              // 排除仅包含空白字符或换行符的 sourceWord
              if (!item.sourceWord || /^\s*$/.test(item.sourceWord)) return false
              // 排除 targetWord 为空的（除非确实是删除建议，需视业务逻辑而定，这里暂且保留非空删除建议）
              // 但用户提到 "\n" -> "" 这种不应该出现，所以我们过滤掉 sourceWord 包含换行符的情况
              if (item.sourceWord.includes('\n') || item.sourceWord.includes('\r')) return false
              return true
            }).map(item => {
              // 简单的上下文截取
              const start = Math.max(0, item.startIndex - 10)
              const end = Math.min(content.length, item.endIndex + 10)
              const rawContext = content.substring(start, end)
              // 在上下文中高亮错误词
              // 注意：简单的 replace 可能会误伤，这里尽量使用 HTML 标签包裹
              // 但 Dialog 内容目前是文本渲染，需要支持 v-html
              item.contextHtml = rawContext.replace(item.sourceWord, `<span style="color: #e2696c; text-decoration: underline wavy #e2696c;">${item.sourceWord}</span>`)
              return item
            })
            
            // 高亮显示错误
            this.HighlightCorrections(this.correctionList)
            
            this.showCorrectionDialog = true
            closeLoading() // 弹窗显示后再关闭 loading
            
            if (this.correctionList.length === 0) {
              if (this.$Toast) this.$Toast('未发现明显错误', 'success')
            }
          } else {
            closeLoading() // 错误时也关闭 loading
            if (this.$Toast) this.$Toast(res.data.message || '检查失败', 'error')
            else alert(res.data.message || '检查失败')
          }
        }).catch(err => {
          if (loadingToast) loadingToast.hide()
          this.$Common.RemoveLoading()
          console.error('Correction error:', err)
          // 优化错误提示，避免直接把对象弹出来
          let msg = '请求失败，请检查网络'
          if (err.response && err.response.data && err.response.data.message) {
            msg = err.response.data.message
          }
          if (this.$Toast) this.$Toast(msg, 'error')
        })
      })
    },
    // 高亮显示错误（简单的 CSS 覆盖）
    HighlightCorrections: function () {
      if (!this.$refs.NoteEditor || !this.$refs.NoteEditor.value) return
      
      // 清除旧的高亮（如果有）
      const oldMarks = document.querySelectorAll('.vditor-correction-mark')
      oldMarks.forEach(el => {
        const text = document.createTextNode(el.innerText)
        el.parentNode.replaceChild(text, el)
      })
      
      // 注意：Vditor 是 Markdown 编辑器，直接操作 DOM 可能会导致编辑器状态混乱
      // 这里的实现方式仅为演示，更稳妥的方式是使用 Vditor 的 addComment 或 setSelection API
      // 但 Vditor 原生 API 对“下划线高亮”支持有限，通常建议在侧边栏显示，点击后跳转选中
      // 这里我们暂时只做“选中高亮”：点击侧边栏列表项时，选中编辑器中的对应文本
    },
    // 定位到错误处
    LocateCorrection: function (item) {
       if (!this.$refs.NoteEditor || !this.$refs.NoteEditor.value) return
       
       // 1. 先关闭弹窗
       this.showCorrectionDialog = false
       
       const editor = this.$refs.NoteEditor.value
       
       try {
         // 2. 延迟执行，等待弹窗关闭和编辑器获取焦点
         setTimeout(() => {
           // 确保编辑器聚焦
           editor.focus()
           
           // 3. 获取当前内容并校验
           const currentContent = editor.getValue()
           let startIndex = item.startIndex
           let endIndex = item.endIndex
           
           // 校验位置
           let targetText = ''
           if (startIndex >= 0 && endIndex <= currentContent.length) {
             targetText = currentContent.substring(startIndex, endIndex)
           }
           
           // 如果位置不对，尝试全文搜索定位
           if (targetText !== item.sourceWord) {
             // 扩大搜索范围：不仅是附近，而是全文搜索
             // 优先从原位置附近搜索
             const nearIndex = currentContent.indexOf(item.sourceWord, Math.max(0, startIndex - 50))
             
             if (nearIndex !== -1 && Math.abs(nearIndex - startIndex) < 200) {
                // 如果在附近找到了，就认为是它
                startIndex = nearIndex
             } else {
                // 如果附近没找到，尝试从头搜索（可能有多个相同的词，这只是尽力而为）
                const firstIndex = currentContent.indexOf(item.sourceWord)
                if (firstIndex !== -1) {
                  startIndex = firstIndex
                } else {
                  if (this.$Toast) this.$Toast(`无法在文档中找到 "${item.sourceWord}"`, 'warning')
                  return
                }
             }
             // 更新结束索引
             endIndex = startIndex + item.sourceWord.length
             
             // 更新 item，方便后续操作
             item.startIndex = startIndex
             item.endIndex = endIndex
           }

           // 4. 调用 Vditor 的 setSelection 方法
           if (typeof editor.setSelection === 'function') {
             editor.setSelection(startIndex, endIndex)
             // 强制聚焦，触发 Vditor 内部的滚动逻辑
             editor.focus()
             
             // 尝试使用 scrollIntoView 让光标可见
             // Vditor 内部渲染区域通常是 .vditor-content 或 .vditor-ir
             // 但由于 setSelection 后，光标位置不一定对应 DOM 元素
             // 我们可以尝试获取当前选区，并滚动到选区
             setTimeout(() => {
                const selection = window.getSelection()
                if (selection.rangeCount > 0) {
                  const range = selection.getRangeAt(0)
                  // const rect = range.getBoundingClientRect()
                  // 如果 rect 都在视口外，或者 top 为 0（不可见），则尝试滚动
                  // 注意：range.getBoundingClientRect() 在某些隐藏元素下可能全为0
                  
                  // 查找 Vditor 的编辑区域容器
                  // const contentElement = document.querySelector('.vditor-content') || document.querySelector('.vditor-ir') || document.querySelector('.vditor-sv')
                  
                  if (range.startContainer && range.startContainer.parentElement) {
                    range.startContainer.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  }
                }
             }, 50)
             
             // 定位成功提示框改为 success
             if (this.$Toast) this.$Toast(`已定位到 "${item.sourceWord}"`, 'success')
           } else {
             // 降级方案
             console.warn('Vditor setSelection not available, falling back to native selection')
             this.FallbackSelection(item.sourceWord)
           }
         }, 300) // 增加延时到 300ms
       } catch (e) {
         console.error('Locate failed:', e)
         if (this.$Toast) this.$Toast('定位发生异常', 'error')
       }
    },
    // 降级定位方案（仅在 Vditor API 失效时使用）
    FallbackSelection: function (text) {
      if (!window.find) return
      // 使用浏览器的查找功能
      const found = window.find(text)
      if (found) {
        if (this.$Toast) this.$Toast(`已定位到 "${text}"`, 'success')
      } else {
        if (this.$Toast) this.$Toast(`请手动查找 "${text}"`, 'warning')
      }
    },
    // 应用纠错建议
    ApplyCorrection: function (item) {
      if (!this.$refs.NoteEditor || !this.$refs.NoteEditor.value) return
      
      const content = this.$refs.NoteEditor.value.getValue()
      
      // 简单的字符串替换可能会有问题（如果有多个相同的词），
      // 严谨的做法是利用 startIndex 和 endIndex
      // 但需要注意：如果用户在检查后修改了文本，索引可能会失效。
      // 这里我们做一个简单的校验：检查该位置的词是否仍与 sourceWord 匹配
      
      const currentSource = content.substring(item.startIndex, item.endIndex)
      if (currentSource !== item.sourceWord) {
        if (this.$Toast) this.$Toast('文档内容已发生变化，建议重新检查', 'warning')
        else alert('文档内容已发生变化，建议重新检查')
        return
      }
      
      const newContent = content.substring(0, item.startIndex) + item.targetWord + content.substring(item.endIndex)
      this.$refs.NoteEditor.value.setValue(newContent)
      
      // 更新列表：移除已修复的项，并调整后续项的索引（暂略复杂，简单起见重新检查或直接关闭）
      // 这里我们简单地从列表中移除该项
      this.correctionList = this.correctionList.filter(c => c !== item)
      
      // 由于内容变了，后续的索引都会偏移，建议提示用户重新检查
      // 或者我们手动更新后续项的索引
      const diff = item.targetWord.length - item.sourceWord.length
      this.correctionList.forEach(c => {
        if (c.startIndex > item.startIndex) {
          c.startIndex += diff
          c.endIndex += diff
        }
      })
      
      // 保存更改
      this.SaveNote()
      if (this.$Toast) this.$Toast('已修改', 'success')
    },
    // 启用主题
    EnableTheme: function (theme) {
      console.log('EnableTheme called with:', theme)
      this.$Common.ApiList(this, 'ThemeEnable').then(url => {
        this.axios.post(`${url}/${theme.id}`).then(res => {
          if (res.data.code === 200) {
            this.activeThemeId = theme.id
            console.log('Applying theme URL:', theme.themeUrl)
            this.ApplyTheme(theme.themeUrl)
            if (this.$Toast) this.$Toast('主题切换成功', 'success')
          } else {
            if (this.$Toast) this.$Toast(res.data.message || '切换失败', 'error')
            else alert(res.data.message || '切换失败')
          }
        })
      })
    },
    // 删除主题
    DeleteTheme: function (theme) {
      if (!confirm(`确定要删除主题 "${theme.themeName}" 吗？`)) return

      this.$Common.ApiList(this, 'ThemeDelete').then(url => {
        this.axios.delete(`${url}/${theme.id}`).then(res => {
          if (res.data.code === 200) {
            // 如果删除的是当前主题，则重置样式
            if (this.activeThemeId === theme.id) {
              this.activeThemeId = null
              this.ApplyTheme(null)
            }
            this.GetThemeList()
            if (this.$Toast) this.$Toast('删除成功', 'success')
          } else {
            if (this.$Toast) this.$Toast(res.data.message || '删除失败', 'error')
            else alert(res.data.message || '删除失败')
          }
        })
      })
    },
    // 应用样式
    ApplyTheme: function (url) {
      console.log('ApplyTheme executing with URL:', url)
      const styleId = 'custom-markdown-theme-style'
      const linkId = 'custom-markdown-theme'
      
      // 移除旧的 link 标签（如果有）
      const oldLink = document.getElementById(linkId)
      if (oldLink) oldLink.remove()

      let style = document.getElementById(styleId)
      
      if (!url) {
        if (style) style.remove()
        return
      }

      // 处理 URL
      let requestUrl = url
      // 如果是腾讯云 COS 的地址，走本地代理以解决 CORS 问题
      const cosHost = 'https://motemd-1382672407.cos.ap-shanghai.myqcloud.com'
      if (requestUrl.startsWith(cosHost)) {
        requestUrl = requestUrl.replace(cosHost, '/cos-proxy')
      }
      
      console.log('Fetching theme from:', requestUrl)

      // 使用原生 fetch 请求
      fetch(requestUrl)
        .then(res => {
          if (!res.ok) {
            console.error('Theme fetch failed with status:', res.status, res.statusText)
            throw new Error(`Network response was not ok: ${res.status}`)
          }
          return res.text()
        })
        .then(cssContent => {
          if (!style) {
            style = document.createElement('style')
            style.id = styleId
            document.head.appendChild(style)
          }
          
          // 将 body, html, #write 选择器替换为 &，以便在嵌套中指向父级
          cssContent = cssContent.replace(/(^|[\s,}])(body|html|#write)(?=[\s,{])/gi, '$1&')
          
          // 修复 Vditor 样式优先级问题：
          // 1. Vditor 自身使用了 .vditor-reset 作为根选择器，如果我们的样式只是嵌套在 .vditor-reset 中，
          //    选择器权重可能相同（如 .vditor-reset p vs .vditor-reset p），导致后加载的生效或顺序依赖。
          // 2. 为了确保自定义主题生效，我们使用 :where() 或直接增加权重
          // 3. 这里采用简单粗暴但有效的方法：将 CSS 中的 .vditor-reset 替换为空（因为我们外层已经包裹了）
          //    或者，更稳妥的是，保持原样，但在外层使用 ID 选择器增加权重
          
          // 方案改进：不使用 CSS Nesting（兼容性问题），而是直接替换选择器
          // 将所有选择器前加上 #NoteEditor .vditor-reset 以提高权重
          // 但这样处理复杂的 CSS 比较困难。
          
          // 回退到 CSS Nesting 方案，但尝试通过 ID 增加权重
          // 注意：Vditor 的内容区域是在 #NoteEditor 内部的 .vditor-reset
          
          // 针对您提到的行内代码样式不生效问题，可能是因为 Vditor 的默认样式使用了 !important 或者权重更高
          // 或者是选择器没匹配上。
          // 您的代码中使用了 .vditor-reset code:not(.hljs)... 
          // 如果我们外层再套一个 .vditor-reset，就变成了 .vditor-reset .vditor-reset code... 
          // 这通常没问题，但如果 CSS 中原本就写了 .vditor-reset，就会重复。
          
          // 预处理：如果 CSS 中已经包含了 .vditor-reset，将其移除，避免重复嵌套
          cssContent = cssContent.replace(/\.vditor-reset/g, '')
          
          style.textContent = `
            #NoteEditor .vditor-reset {
              ${cssContent}
            }
          `
          console.log('Theme applied successfully')
        })
        .catch(err => {
          console.error('Failed to load theme:', err)
          // 移除可能存在的 style 标签
          if (style) style.remove()
          
          let msg = '主题加载失败'
          if (err.message && (err.message.includes('Network') || err.message.includes('CORS') || err.message.includes('Failed to fetch'))) {
            msg += '：网络错误或跨域限制(CORS)。请确保云存储 Bucket 已配置允许跨域访问。'
          }
          if (this.$Toast) this.$Toast(msg, 'error')
        })
    },
    // 处理选择变化
    HandleSelectionChange: function () {
      const selection = window.getSelection()
      if (!selection) return
      
      // 如果没有选中文本，或者是光标状态，则隐藏 AI 按钮
      if (selection.isCollapsed || selection.toString().trim() === '') {
        this.aiButtonVisible = false
        return
      }
      
      // 如果选区不在编辑器内
      if (this.$refs.NoteEditor && selection.anchorNode) {
        if (!this.$refs.NoteEditor.contains(selection.anchorNode)) {
          this.aiButtonVisible = false
        }
      }
    }
  },
  mounted () {
    // 再次确认：如果当前路由是分享页，绝对不要执行 Note 页面的逻辑
    if (this.$route.path && this.$route.path.startsWith('/share/')) return
    
    this.$Common.SetDocTitle(this)
    this.InitEditor().then(() => { this.GetNote() })

    // 监听全局选择变化，处理 AI 按钮隐藏
    document.addEventListener('selectionchange', this.HandleSelectionChange)
  },
  beforeUnmount () {
    // 移除监听
    document.removeEventListener('selectionchange', this.HandleSelectionChange)

    // 组件销毁前（如关闭页面），如果有未保存的标题修改，立即保存
    if (this.renameTimer) {
      this.RenameNode()
    }
  },
  watch: {
    $route: function (current) {
      // 路由切换前（如切换文档），如果有未保存的标题修改，立即保存
      if (this.renameTimer) {
        this.RenameNode()
      }
      if (current.path === '/Index/Note') {
        this.InitEditor().then(() => { this.GetNote() })
      }
    }
  }
}
</script>

<style scoped>
  .Note {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* 防止整体滚动 */
    background: #ffffff; /* 确保背景为白色 */
  }

  #NoteEditor {
    /* height: calc(100% - 50px); */
    flex: 1;
    height: 0; /* 关键：触发 flex 计算，防止内容撑开容器 */
    min-height: 0;
    border: unset;
    background: #ffffff; /* 确保背景为白色 */
  }

  /* 降低优先级以支持自定义主题 */
  #NoteEditor :deep(.vditor-content) {
    background: #ffffff; /* 确保 Vditor 内容区域背景为白色 */
    position: relative; /* 确保子元素绝对定位基于此容器 */
  }

  #NoteEditor :deep(.vditor-outline) {
    position: absolute !important;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 10;
    background: #ffffff;
    border-right: 1px solid #eee;
  }

  #NoteEditor :deep(.vditor-toolbar),
  #NoteEditor :deep(.vditor-reset),
  #NoteEditor :deep(.vditor-outline),
  #NoteEditor :deep(.vditor-preview),
  #NoteEditor :deep(.vditor-preview__action),
  #NoteEditor :deep(.vditor-preview__action button) {
    background: #ffffff;
  }

  #NoteEditor :deep(.vditor-reset) {
    font-family: "Open Sans", "Clear Sans", "Helvetica Neue", Helvetica, Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";
    color: #333;
    line-height: 1.6;
    font-size: 16px;
    padding: 20px 40px !important;
    max-width: 900px;
    margin: 0 auto;
  }

  #NoteEditor :deep(.vditor-reset h1),
  #NoteEditor :deep(.vditor-reset h2) {
    border-bottom: 1px solid #eaecef;
    padding-bottom: .3em;
    margin-bottom: 16px;
  }

  #NoteEditor :deep(.vditor-reset h1) {
    font-size: 2em;
    font-weight: 600;
  }

  #NoteEditor :deep(.vditor-reset h2) {
    font-size: 1.5em;
    font-weight: 600;
  }

  #NoteEditor :deep(.vditor-reset blockquote) {
    border-left: 4px solid #dfe2e5;
    color: #6a737d;
    background-color: transparent;
    padding: 0 1em;
  }

  #NoteEditor :deep(.vditor-reset a) {
    color: #0366d6;
    text-decoration: none;
  }

  #NoteEditor :deep(.vditor-reset a:hover) {
    text-decoration: underline;
  }

  #NoteEditor :deep(.vditor-reset table) {
    border-collapse: collapse;
    border-spacing: 0;
  }
  
  #NoteEditor :deep(.vditor-reset table tr) {
    background-color: #fff;
    border-top: 1px solid #c6cbd1;
  }
  
  #NoteEditor :deep(.vditor-reset table tr:nth-child(2n)) {
    background-color: #f6f8fa;
  }

  #NoteEditor :deep(.vditor-reset table th),
  #NoteEditor :deep(.vditor-reset table td) {
    padding: 6px 13px;
    border: 1px solid #dfe2e5;
  }

  #NoteEditor :deep(.vditor-preview__action--current) {
    background: var(--ccs-primary-color) !important;
    border-radius: 10px;
    color: #fff;
  }

  #NoteEditor :deep(.vditor-panel),
  #NoteEditor :deep(.vditor-hint),
  #NoteEditor :deep(.vditor-tip__content) {
    background: #ffffff;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid #eee;
  }

  #NoteEditor :deep(.vditor-toolbar) {
    border: unset;
    border-bottom: 1px solid #eee;
    padding: unset !important;
    display: flex;
    justify-content: center;
  }

  #NoteEditor :deep(.vditor-outline__content) {
    color: var(--ccs-primary-font-color);
  }

  #NoteEditor :deep(.vditor-panel--none) {
    padding: 5px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    margin-top: -15px;
  }

  .Note .Title {
    flex: 0 0 50px; /* 固定高度，不可伸缩 */
    height: 50px;
    padding: 0;
    position: relative;
    z-index: 100;
    background: #ffffff; /* 确保背景不透明 */
    border-bottom: 1px solid #eee;
  }

  .Note .Title input {
    --paddingLeftRight: 10px;
    width: 100%;
    height: 100%;
    padding: 10px var(--paddingLeftRight);
    text-align: center;
    border: unset;
    background: transparent;
    color: var(--ccs-primary-font-color);
    font-size: 18px;
    font-weight: bold;
    outline: none;
  }

  /* Mobile Styles */
  @media screen and (max-width: 768px) {
    .Note {
      padding: 0;
    }
    
    #NoteEditor :deep(.vditor-toolbar) {
      padding-left: 5px !important;
      padding-right: 5px !important;
      overflow-x: auto;
      justify-content: flex-start; /* Allow scroll */
      -webkit-overflow-scrolling: touch;
    }
    
    #NoteEditor :deep(.vditor-content .vditor-reset) {
      padding: 10px 15px !important;
    }
    
    .Note .Title {
      height: 40px;
      flex: 0 0 40px;
    }
    
    .Note .Title input {
      font-size: 16px;
    }
  }
</style>
